export default "__VITE_ASSET__CtM_3qov__"